export const titles = [
    {
        label: "Mr",
        value: "Mr"
    },
    {
        label: "Mrs",
        value: "Mrs"
    },
    {
        label: "Ms",
        value: "Ms"
    },
    {
        label: "Miss",
        value: "Miss"
    },
    {
        label: "Master",
        value: "Master"
    }
]